module.exports = __webpack_public_path__ + "static/media/BannerConfirmationGoService.64f1a0b8.png";